import i18n from "../../i18n";
import React from "react";
import { Leaf, ShieldCheck, Sprout, Sun, Users } from "lucide-react";

const LEGACY_STEPS = [
    [Sun, "WE PLAN TODAY"],
    [Sprout, "WE BUILD STRONG"],
    [Users, "WE GROW TOGETHER"],
    [ShieldCheck, "WE PROTECT & IMPROVE"],
    [Leaf, "WE CONTINUE THE LEGACY"],
];

export default function LegacyBanner() {
    return (
        <section className="aj-legacy-banner" aria-labelledby="aj-legacy-title" data-testid="dashboard-legacy-banner">
            <div className="aj-legacy-sun" aria-hidden="true" />
            <div className="relative z-10">
                <div className="grid grid-cols-1 sm:grid-cols-5 gap-2">
                    {LEGACY_STEPS.map(([Icon, text]) => (
                        <div key={text} className="aj-legacy-step">
                            <Icon className="w-5 h-5" aria-hidden="true" />
                            <span>{text}</span>
                        </div>
                    ))}
                </div>
                <div className="mt-7 pt-6 border-t border-aj-gold/20 grid md:grid-cols-[1fr_auto] gap-5 items-end">
                    <div>
                        <div id="aj-legacy-title" className="text-aj-gold text-sm tracking-[0.28em] font-bold">{i18n.t("final.e6469a65672a")}</div>
                        <p className="mt-2 text-2xl sm:text-3xl font-bold leading-tight text-white">{i18n.t("final.9338d7d6f677")}<br className="hidden sm:block" /> {i18n.t("final.38eb50e0cbea")}</p>
                        <p className="mt-3 text-[10px] sm:text-xs tracking-[0.16em] text-white/50 uppercase">{i18n.t("final.f64a2d812f7d")}</p>
                    </div>
                    <div className="text-xs tracking-[0.22em] text-white/55 font-semibold">{i18n.t("final.cf86f160deef")}</div>
                </div>
            </div>
        </section>
    );
}
